import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../../../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../../../../../components/MaterialDataGrid";
import MaterialTypography from "../../../../../../components/MaterialTypography";
import { Card, CardHeader, CardContent, Typography, Grid, Stack, Button, TextField } from '@mui/material';
import MaterialButton from "../../../../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../../../../../Utils/Baseurl";

function ViewScreen() {
   const [employeeData,setemployeeData] = useState([])
   const navigate = useNavigate()
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search)
        const id = queryParams.get("id")
        
        if (id) {
          getemployeedata(id)
        }
       
    }, [])


    const getemployeedata = async(id)=>{
        const query = `query getUserDetail($id: String!) {
    userDetail(Id: $id) {
      id
      lastLogin
      username
      firstName
      lastName
      isActive
      dateJoined
      email
      salutation
      dateOfBirth
      contactNumber
      emergencyContact
      gender
      teamleader
      employeeType
      lastUpdate
      department
      designation
      empid
      grade
      probationPeriod
      aadharNumber
      panNumber
      password
      secondaryContactNumber
      role
      officialMail
      address
      city
      country
      zipCode
      state
      maritalStatus
      previousExperience
      otApplicable
      shift
      uanNumber
      memberId
      esicNumber
      fathersName
      bankDetails {
        bankName
        accountNumber
        branchName
        ifscNumber
        cifNumber
      }
    }
  }
  `
            try {
              const response = await axios.post(BASEURL, {
                query: query,
                variables: { id },
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
         
            let result = response.data.data.userDetail
            
            setemployeeData(result)  
            } catch (error) {
              console.error('ReponseError:',error);
              
            }
   
     }

     function formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB'); // This will return 'dd/mm/yyyy' format
      }

      const handleclose = ()=>{
        navigate('/employee-management')
      }
   
  return (
    <DashboardLayout>
    <Card>
        <CardHeader
          title={
            <Stack direction="column" spacing={0}>
              <Typography variant="h5" fontWeight="bold">
                Employee Details
              </Typography>
            </Stack>
          }
        />
        <CardContent>
        <Grid container spacing={2} justifyContent="center" alignItems="flex-start" padding={1}>
  {/* Left Column */}
  <Grid item xs={12} sm={6} md={5}>
    <Stack spacing={2}>
      <Typography variant="h6" fontWeight="bold">
        First Name: <span style={{ color: "#67748E" }}>{employeeData.firstName}</span>
      </Typography>
      <Typography variant="h6" fontWeight="bold">
        Employee ID: <span style={{ color: "#67748E" }}>{employeeData.empid}</span>
      </Typography>
      <Typography variant="h6" fontWeight="bold">
        Father's Name: <span style={{ color: "#67748E" }}>{employeeData.fathersName}</span>
      </Typography>
      <Typography variant="h6" fontWeight="bold">
        Country: <span style={{ color: "#67748E" }}>{employeeData.country}</span>
      </Typography>
      <Typography variant="h6" fontWeight="bold">
        City: <span style={{ color: "#67748E" }}>{employeeData.city}</span>
      </Typography>
      <Typography variant="h6" fontWeight="bold">
        Contact Number: <span style={{ color: "#67748E" }}>{employeeData.contactNumber}</span>
      </Typography>
      <Typography variant="h6" fontWeight="bold">
        Department: <span style={{ color: "#67748E" }}>{employeeData.department}</span>
      </Typography>
      <Typography variant="h6" fontWeight="bold">
        Manager: <span style={{ color: "#67748E" }}>{employeeData.teamleader}</span>
      </Typography>
    </Stack>
  </Grid>

  {/* Right Column */}
  <Grid item xs={12} sm={6} md={5}>
    <Stack spacing={2}>
      <Typography variant="h6" fontWeight="bold">
        Last Name: <span style={{ color: "#67748E" }}>{employeeData.lastName}</span>
      </Typography>
      <Typography variant="h6" fontWeight="bold">
        Mail ID: <span style={{ color: "#67748E" }}>{employeeData.email}</span>
      </Typography>
      <Typography variant="h6" fontWeight="bold">
        Address: <span style={{ color: "#67748E" }}>{employeeData.address}</span>
      </Typography>
      <Typography variant="h6" fontWeight="bold">
        State: <span style={{ color: "#67748E" }}>{employeeData.state}</span>
      </Typography>
      <Typography variant="h6" fontWeight="bold">
        Zip Code: <span style={{ color: "#67748E" }}>{employeeData.zipCode}</span>
      </Typography>
      <Typography variant="h6" fontWeight="bold">
        Secondary Number: <span style={{ color: "#67748E" }}>{employeeData.secondaryContactNumber}</span>
      </Typography>
      <Typography variant="h6" fontWeight="bold">
        Date of Joining: <span style={{ color: "#67748E" }}>{formatDate(employeeData.dateJoined)}</span>
      </Typography>
      <Typography variant="h6" fontWeight="bold">
        Position: <span style={{ color: "#67748E" }}>{employeeData.designation}</span>
      </Typography>
    </Stack>
  </Grid>

  {/* Close Button */}
  <Grid item xs={12} textAlign="center" marginTop={3}>
    <MaterialButton
      variant="gradient"
      color="dark"
      onClick={handleclose}
      style={{ maxWidth: "100px", minWidth: "100px" }}
    >
      Close
    </MaterialButton>
  </Grid>
</Grid>

         
        </CardContent>
      </Card>
  </DashboardLayout>
  );
}

export default ViewScreen;
